import './CopyB.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';

export interface CopyBContentType {}

interface CopyBProps extends CopyBContentType {
  background?: b2x.contentTypes.AssetAsBackgroundContentSectionV2;
  content?: string;
  cta?: b2x.contentTypes.CtaContentSection;
  mainComponent?: boolean;
  options?: {
    contentColor?: string;
    textAlign?: string;
    titleColor?: string;
  };
  title?: string;
}

export const CopyB = ({ background, content, cta, mainComponent, options, title }: CopyBProps) => {
  const _textAlign: b2x.TextAlign =
    options?.textAlign === 'start'
      ? 'start'
      : options?.textAlign === 'center'
      ? 'center'
      : options?.textAlign === 'end'
      ? 'end'
      : 'start';
  return (
    <b2x.Div className="copy-b">
      <Container fluid="always">
        <b2x.Div style={{ position: 'relative' }}>
          <b2x.Div
            alignItems={'center'}
            display={'flex'}
            justifyContent={'center'}
            paddingX={3}
            paddingY={5}
            style={{ position: 'relative', zIndex: 100 }}
          >
            <b2x.Row justifyContent={'center'}>
              <b2x.Col size={{ lg: 8, md: 10, xl: 6, xs: 12 }}>
                <b2x.Div paddingY={5} textAlign={_textAlign}>
                  <b2x.ConditionalWrapper
                    condition={title !== undefined}
                    wrapper={
                      mainComponent ? (
                        <b2x.H1
                          className="title"
                          fontWeight={700}
                          marginBottom={4}
                          style={{ color: options?.titleColor ?? undefined }}
                        />
                      ) : (
                        <b2x.P
                          className="title"
                          fontWeight={700}
                          marginBottom={4}
                          style={{ color: options?.titleColor ?? undefined }}
                        />
                      )
                    }
                  >
                    {b2x.formatHtml(title)}
                  </b2x.ConditionalWrapper>
                  <b2x.Div className="content" marginBottom={5} style={{ color: options?.contentColor ?? undefined }}>
                    {b2x.formatHtml(content)}
                  </b2x.Div>
                  <b2x.CtaFromContent {...cta} />
                </b2x.Div>
              </b2x.Col>
            </b2x.Row>
          </b2x.Div>

          {background && (
            <div className="position-absolute start-0 top-0 w-100 h-100">
              <b2x.AssetAsBackgroundV2 {...background} />
            </div>
          )}
        </b2x.Div>
      </Container>
    </b2x.Div>
  );
};
